/**
 * **源语言。** 其它语言的键以它为准 —— `test/i18n.test.ts` 会比对，
 * 少一个键或多一个键都红。
 *
 * 键名用 `域.名字`，扁平不嵌套：好 grep（改文案时能一眼找到用在哪）、
 * 好 diff（加一行就是加一行，不会因为嵌套层级变动搅乱整块）。
 *
 * 复数：英语葡语要区分单复数，中文不用。约定是同一个键带 `_one` / `_other`
 * 后缀，由 `Intl.PluralRules` 选 —— 中文两个写成一样就行。
 */
export const zhCN = {
  'tab.lobby': '大厅',
  'tab.activity': '活动',
  'tab.agent': '代理',
  'tab.deposit': '充值',
  'tab.profile': '个人',

  'action.loginOrRegister': '登录 / 注册',
  'action.login': '登录',
  'action.register': '注册',
  'action.close': '关闭',
  'action.settings': '设置',
  'action.myAccount': '我的账号',
  'action.working': '请稍候…',
  'action.view': '查看',
  'action.retry': '重试',

  'lobby.hot': '热门',
  'lobby.more': '更多',
  'lobby.less': '收起',
  'lobby.providers': '游戏厂商',
  'lobby.allProviders': '全部',
  'lobby.otherProvider': '其他',
  'lobby.title': '大厅',
  'lobby.count_one': '{n} 款',
  'lobby.count_other': '{n} 款',
  'lobby.none': '暂时没有可玩的游戏',
  'lobby.maintenance': '维护中',
  'lobby.unavailable': '暂不可用',
  'lobby.laterNote': '分类、最近在玩、厂商筛选 —— 之后再做。',
  'lobby.search': '搜索游戏',
  'lobby.noMatch': '没有找到“{q}”',
  'lobby.liveTables': '真人牌桌',
  'lobby.tableClosed': '牌桌已关闭',
  'lobby.liveUnavailable': '实时数据暂不可用',
  'lobby.dealer': '荷官',
  'lobby.betLimits': '下注范围',
  'lobby.players': '在桌人数',
  'lobby.seats': '空位',
  'lobby.recentResults': '最近结果',
  'lobby.shoe': '庄 / 闲 / 和',
  'lobby.newTable': '新桌',

  'game.tag_one': '{provider} · {grid} · {n} 线',
  'game.tag_other': '{provider} · {grid} · {n} 线',
  'game.tagGrid': '{provider} · {grid}',
  'game.tagLines_one': '{provider} · {n} 线',
  'game.tagLines_other': '{provider} · {n} 线',

  'placeholder.activity': '活动、任务、签到、排行榜 —— 还没做',
  'placeholder.agent': '分享链接、下级列表、返佣结算 —— 还没做',
  'placeholder.deposit': '充值提现要先有账务系统',
  'placeholder.profile': '账号资料、投注记录、安全设置 —— 骨架见设置菜单',

  'auth.phone': '手机号',
  'auth.phoneHint': '选择国家后输入手机号，例如 {example}',
  'auth.countryLoading': '正在加载国家区号…',
  'auth.countryLoadFailed': '无法加载国家区号，请重试。',
  'auth.registrationClosed': '暂未开放新用户注册，已有账号可登录。',
  'err.REGISTRATION_COUNTRY_DISABLED': '该国家暂未开放注册，请选择已开放的国家。',
  'auth.countryCode': '国家区号',
  'auth.country.PH': '菲律宾',
  'auth.country.BR': '巴西',
  'auth.password': '密码',
  'auth.passwordHint': '至少 8 位',
  'auth.toRegister': '还没有账号？去注册',
  'auth.toLogin': '已经有账号？去登录',
  'auth.noSmsYet': '短信验证还没做，现在注册不会收到验证码。',

  'err.BAD_CREDENTIALS': '手机号或密码不对',
  'err.IDENTIFIER_TAKEN': '这个手机号已经注册过了',
  'err.WEAK_PASSWORD': '密码至少 8 位',
  'err.ACCOUNT_LOCKED': '尝试次数过多，请稍后再试',
  'err.ACCOUNT_DISABLED': '这个账号已被冻结',
  'err.NO_SESSION': '登录已过期，请重新登录',
  'err.BAD_PHONE': '手机号格式不对，请检查所选国家和号码',
  'history.status.open': '进行中',
  'history.status.aborted': '待结算',
  'history.status.settled': '已结算',
  'history.status.canceled': '已取消',
  'history.title': '投注历史',
  'history.empty': '还没有任何一局',
  'history.free': '免费局',
  'history.reward': '独立奖励',
  'history.adjustment': '调整',
  'history.more': '加载更多',

  'err.GAME_UNAVAILABLE': '这个游戏暂时进不去，稍后再试',
  'err.NETWORK': '连不上服务器',
  'err.UNKNOWN': '出错了，请稍后再试',

  'profile.balance': '余额',
  'profile.vip': 'VIP 等级',
  'profile.wager': '打码量',
  'profile.wagerNone': '当前没有打码要求',
  'profile.wagerDone': '已达标',
  'profile.rounds': '累计局数',
  'profile.noNickname': '还没起名字',
  'profile.editNickname': '修改昵称',
  'profile.nickname': '昵称',
  'profile.nicknameHint': '1~24 个字符',
  'profile.nicknameNotUnique': '昵称可以重复，账号身份始终以你的 ID 为准。',
  'profile.renamesLeft_one': '还可以改名 {n} 次',
  'profile.renamesLeft_other': '还可以改名 {n} 次',
  'profile.renamesNone': '改名次数已用完',
  'profile.idLabel': 'ID {v}',
  'profile.copyId': '复制 ID',
  'profile.idCopied': '已复制',
  'profile.copyFailed': '复制失败，长按 ID 手动复制',
  'err.NICKNAME_RENAME_LIMIT': '改名次数已经用完了',
  'err.BAD_NICKNAME': '昵称不合法',
  'err.NICKNAME_CHARS': '昵称里有看不见的字符（可能是从别处复制来的），请手动输入',
  'action.save': '保存',
  'profile.changeAvatar': '换头像',
  'profile.uploadOwn': '上传自己的图片',
  'profile.uploadHint': 'JPG / PNG / WebP，不超过 512 KB',
  'profile.yourUpload': '你上传的',
  'profile.deposited': '累计充值 {v}',
  'profile.maxLevel': '已经是最高等级',
  'profile.toNextLevel': '再充 {v} 升到 VIP {n}',
  'profile.perkFreeSpins': '每日免费局',
  'profile.perkDiscount': '充值加送',
  'profile.freeSpinsLeft': '剩余免费局',
  'profile.claimDaily': '领取今日奖励',
  'profile.claimed': '今天已领取',
  'profile.noRewardYet': '暂无可领奖励',
  'profile.rewardFromLevel': '升到 VIP {n} 后每日可领免费局',
  'vip.title': 'VIP 等级说明',
  'vip.level': '等级',
  'vip.threshold': '累计充值',
  'vip.withdrawLimit': '每日提现',
  'vip.you': '当前',
  'vip.basis': 'VIP 等级按累计有效充值金额计算。',
  'vip.noteClaim': '每日免费局需要在个人页手动领取，每天一次，领了就属于你。',
  'vip.noteDiscount': '充值加送和每日提现额度是当前等级的权益，不需要领取。',
  'vip.noteMinWithdraw': '单笔最低提现 {v}。',
  'vip.noteMonotonic': '累计充值只增不减，等级不会因为提现或活动结束而下降。',
  'vip.open': '查看 VIP 说明',
  'err.NOTHING_TO_CLAIM': '当前等级暂无可领奖励',
  'err.ALREADY_CLAIMED': '今天已经领过了',
  'err.INSUFFICIENT_FUNDS': '余额不足',
  'err.BAD_REQUEST': '填写的内容不合法',

  'settings.title': '设置',
  'settings.skin': '皮肤',
  'settings.mode': '深浅',
  'settings.language': '语言',
  'settings.account': '账号',
  'settings.notLoggedIn': '还没登录。',
  'settings.playerId': '玩家 ID',
  'settings.devices': '登录中的设备',
  'settings.loading': '读取中…',
  'settings.unknownDevice': '未知设备',
  'settings.current': '当前',
  'settings.revokeOthers': '退出其他设备',
  'settings.logout': '退出登录',

  'skin.laroluna': 'LaroLuna · 月光',
  'luna.title': '发现下一款心动游戏',
  'luna.note': '月光相伴，尽兴探索。',
  'skin.midnight': '午夜',
  'skin.sunset': '落日',
  'mode.system': '跟随系统',
  'mode.dark': '深色',
  'mode.light': '浅色',

  'time.justNow': '刚刚活跃',
  'time.minutesAgo_one': '{n} 分钟前',
  'time.minutesAgo_other': '{n} 分钟前',
  'time.hoursAgo_one': '{n} 小时前',
  'time.hoursAgo_other': '{n} 小时前',
  'time.daysAgo_one': '{n} 天前',
  'time.daysAgo_other': '{n} 天前',

  // ---- 充值 ----
  'shop.title': '充值',
  'shop.buy': '购买',
  'shop.bought': '已到账',
  'shop.getCoins': '到账 {v}',
  'shop.bonus': '多送 {v}',
  'shop.origPrice': '原价 {v}',
  'shop.soldOut': '今日已购完',
  'shop.leftToday_one': '今日还可购买 {n} 次',
  'shop.leftToday_other': '今日还可购买 {n} 次',
  'shop.limitToday_one': '每日限购 {n} 次',
  'shop.limitToday_other': '每日限购 {n} 次',
  'shop.empty': '暂无可购买的商品',
  'shop.devPay': '当前为开发环境：点击购买后直接到账，未接入真实支付。',
  'shop.tag.hot': '热门',
  'shop.tag.best': '超值',
  'shop.tag.daily': '每日',
  'shop.tag.first': '首充',
  'shop.history': '购买记录',
  'shop.noHistory': '还没有购买记录',
  'shop.st.created': '待支付',
  'shop.st.paid': '到账中',
  'shop.st.credited': '已到账',
  'shop.st.cancelled': '已取消',
  'shop.st.expired': '已过期',

  'err.PRODUCT_UNAVAILABLE': '这个商品当前不可购买',
  'err.PURCHASE_LIMIT': '今天这个商品已经买满了',
  'err.CREDIT_FAILED': '支付成功但到账失败，请联系客服',

  // ---- 提现 / 收款身份 ----
  'withdraw.title': '提现',
  'withdraw.action': '提现',
  'withdraw.available': '可提现余额',
  'withdraw.payoutTo': '收款信息',
  'withdraw.noIdentity': '还没有收款信息',
  'withdraw.bindFirst': '提现前需要先绑定收款人 CPF',
  'withdraw.cpf': 'CPF',
  'withdraw.cpfHint': '11 位数字，例如 {example}',
  'withdraw.holderName': '收款人姓名',
  'withdraw.holderNameHint': '要和 CPF 上的姓名一致，银行会核对',
  'withdraw.bind': '绑定收款信息',
  'withdraw.bound': '已绑定',
  'withdraw.cannotUnbind': '绑定后不能自行修改。需要更换请联系客服。',
  'withdraw.oncePerAccount': '一个账号只能绑定一个 CPF，一个 CPF 也只能用于一个账号。',
  'withdraw.wagerBlocked': '打码量未达标，还差 {v}',
  'withdraw.notOpenYet': '提现通道即将开放，收款信息可以先绑好。',

  'err.BAD_CPF': 'CPF 格式或校验不通过，请检查',
  'err.IDENTITY_TAKEN': '这个 CPF 已经被使用了',
  'err.IDENTITY_ALREADY_BOUND': '这个账号已经绑过收款信息了',

  'withdraw.amount': '提现金额',
  'withdraw.amountHint': '{min} ~ {max}',
  'withdraw.submit': '提交申请',
  'withdraw.submitted': '申请已提交，等待审核',
  'withdraw.all': '全部',
  'withdraw.dailyLimit': '今日额度',
  'withdraw.dailyLeft': '剩余 {v}',
  'withdraw.vipTip': 'VIP {n} 每日可提 {v}，充值可提升额度',
  'withdraw.history': '提现记录',
  'withdraw.noHistory': '还没有提现记录',
  'withdraw.st.pending': '待审核',
  'withdraw.st.approved': '已通过',
  'withdraw.st.rejected': '已驳回',
  'withdraw.refunded': '金额已退回余额',
  // ---- 站内信 ----
  // **文案在前端，后端只给模板键 + 参数** —— 玩家会换语言，
  // 而信箱里的是历史记录，存成一种语言就再也换不回来了。
  'mail.title': '站内信',
  'mail.entry': '站内信',
  'mail.empty': '还没有消息',
  'mail.unknown.title': '新消息',
  'mail.unknown.body': '你有一条新消息。',
  'mail.withdrawPaid.title': '提现已到账',
  'mail.withdrawPaid.body': '提现 {amount} 已到账，实际到账 {net}（手续费 {fee}）。',
  'mail.withdrawFailed.title': '提现失败',
  'mail.withdrawFailed.body': '提现 {amount} 打款失败，金额已全额退回你的余额。',
  'mail.withdrawRejected.title': '提现被驳回',
  'mail.withdrawRejected.body': '提现 {amount} 未通过审核，金额已全额退回你的余额。',
  'mail.attachment': '附件',
  'mail.coins': '金币 {v}',
  'mail.wager': '打码量 {v}',
  'mail.wagerNote': '领取后，提现前需要再完成这部分打码量',
  'mail.claim': '领取',
  'mail.claimed': '已领取',
  'mail.claimedOk': '已领取 {v}',
  'mail.claimedOkWager': '已领取 {v}，打码要求增加 {w}',
  'err.NO_SUCH_MAIL': '这封信不存在',
  'action.more': '加载更多',

  'withdraw.fee': '手续费',
  'withdraw.feeFree': '免手续费',
  'withdraw.net': '实际到账',
  'withdraw.feeFreeAt': 'VIP {n} 起免手续费',
  'withdraw.itemFee': '手续费 {f} · 到账 {v}',
  'withdraw.submittedFee': '申请已提交，到账 {v}（手续费 {f}）',
  'withdraw.noQuotaLeft': '今日额度已用完',

  'err.NO_PAYOUT_IDENTITY': '请先绑定收款信息',
  'err.WAGER_NOT_MET': '打码量未达标',
  'err.WITHDRAW_TOO_SMALL': '金额低于单笔最低额',
  'err.WITHDRAW_OVER_LIMIT': '超过今日提现额度',
  'err.WITHDRAW_NOT_PENDING': '这笔订单已经处理过了',

  // ---------------------------------------------------------------- 分享/代理
  'ref.needLogin': '登录后才能看到你的分享链接',
  'ref.myLink': '我的分享链接',
  'ref.copy': '复制',
  'ref.copied': '已复制',
  'ref.code': '邀请码：{v}',
  'ref.pending': '待领返点',
  'ref.claim': '领取',
  'ref.claimed': '已领取 {v}，免费局 +{n}',
  'ref.claimedCash': '已领取 {v}',
  'ref.spins_one': '{n} 局免费',
  'ref.spins_other': '{n} 局免费',
  'ref.team': '我的团队',
  'ref.level': '{n} 级',
  'ref.effN_one': '有效 {n} 人',
  'ref.effN_other': '有效 {n} 人',
  'ref.tapForList': '点一下看名单',
  'ref.levelTitle': '{n} 级下级',
  'ref.total_one': '共 {n} 人',
  'ref.total_other': '共 {n} 人',
  'ref.noOne': '这一级还没有人',
  'ref.noName': '未设置昵称',
  'ref.effective': '有效',
  'ref.notEffective': '未达标',
  'ref.prev': '上一页',
  'ref.next': '下一页',
  'ref.chests': '宝箱',
  'ref.needN_one': '{n} 个有效',
  'ref.needN_other': '{n} 个有效',
  'ref.leftN_one': '还差 {n} 个',
  'ref.leftN_other': '还差 {n} 个',
  'ref.open': '开启',
  'ref.claimedOne': '已开启',
  'ref.chestGot': '开出 {v}，免费局 +{n}',
  'ref.chestGotCash': '开出 {v}',
  'ref.rules': '分享规则',
  'ref.r1': '朋友通过你的链接注册，就成为你的一级下级；他的下级是你的二级，再往下是三级。',
  'ref.r2': '下级累计充值满 {d} 且累计投注满 {b}，才算你的有效下级。',
  'ref.r3': '返点最多计算 {n} 级，比例见下表，按下级的实付金额计算。',
  'ref.r4': '返点不会自动到账，要在这一页点“领取”。有效一级下级达到档位可以开宝箱，每档只能开一次。',
  'ref.tLevel': '层级',
  'ref.tRate': '返点比例',
  'ref.tSpins': '免费局',
  'ref.version': '规则版本 {v}',

  // ---------------------------------------------------------------- 收款
  'pay.title': '完成支付',
  'pay.amount': '需支付',
  'pay.copy': '复制 PIX 码',
  'pay.copied': '已复制',
  'pay.howto': '复制之后打开你的银行 App，选择 PIX「粘贴复制码」完成支付。',
  'pay.noCode': '这个渠道没有提供复制码，请用下面的支付页完成。',
  'pay.openPage': '打开支付页',
  'pay.expiresIn': '{v} 后失效',
  'pay.waiting': '付完之后这里会自动到账，不用离开这个页面。',
  'pay.crediting': '已收到款项，正在到账…',
  'pay.done': '已到账',
  'pay.orderNo': '订单号',
  'pay.st.expired': '付款码已失效',
  'pay.st.cancelled': '这笔订单已取消',
  'pay.again': '重新下单',

  // ---------------------------------------------------------------- 内嵌页
  'action.back': '返回',
  'frame.blocked': '这个页面不允许被嵌入。请改用下面的方式完成。',
  'frame.pay': '支付',
  'frame.game': '游戏',
  'frame.gameBlocked': '游戏加载失败，请稍后再试。',
  'frame.exitGame': '返回大厅',
  'pay.toastOk': '充值已到账，金币 +{v}',
} as const;

/**
 * 目录里**实际存在**的键。每种语言都必须给全这些 —— 少一个多一个都编译错误，
 * `test/i18n.test.ts` 再兜一道。
 */
export type RawKey = keyof typeof zhCN;

/** `xxx_one` / `xxx_other` 去掉后缀之后的"词条名"。 */
type PluralBase<K> = K extends `${infer B}_one` ? B
  : K extends `${infer B}_other` ? B : never;

/**
 * `t()` 收的键：实际键 **加上**复数词条的基名。
 *
 * 分成两个类型是有原因的：调用方写 `t('lobby.count', {n
})`，
 * 而目录里存的是 `lobby.count_one` / `lobby.count_other` ——
 * 用同一个类型的话，要么调用方得自己拼后缀（那复数规则就漏到界面代码里了），
 * 要么目录被允许缺 `_one`（那英语就会显示 "1 games"）。
 */
export type MessageKey = RawKey | PluralBase<RawKey>;
